import ReactGA from 'react-ga4';

import { getCookiePreferences } from '/business/shared/functions/cookiePreferences';
import { googleTag4TrackingCode } from '/shared/util/Statics';

type PageViewPayload = Record<string, string | number | boolean | null | undefined>;

function initialize() {
  if (!getCookiePreferences().hotjar) {
    return null;
  }
  if (!googleTag4TrackingCode) {
    return null;
  }
  ReactGA.initialize(googleTag4TrackingCode);
}

function triggerPageview(ops: PageViewPayload) {
  if (!getCookiePreferences().hotjar) {
    return null;
  }

  ReactGA.send({ hitType: 'pageview', ...ops });
}

export default {
  initialize,
  triggerPageview,
};
